
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Optional,
} from "@angular/core";
import { UserserviceService } from "src/app/Services/userservice.service";
import { Router, ActivatedRoute } from "@angular/router";
import { DataService } from "src/app/Services/dataservice.service";
import { HttpClient, HttpEvent, HttpEventType, HttpResponse } from "@angular/common/http";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { environment } from "src/environments/environment";
import { MediaUploadService } from "src/app/Services/media-upload.service";
import { ToastrService } from "ngx-toastr";
import { GetContentService } from "src/app/Services/getcontent.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { SelectionRephraseAIComponent } from "../selection-rephraseAi-dialog/selection-rephraseAi-dialog.component";
import { title } from "process";

@Component({
  selector: "app-steps",
  templateUrl: "./steps.component.html",
  styleUrls: ["./steps.component.scss"],
})
export class StepsComponent implements OnInit {
  showNotificationCount: boolean;
  notificationCount: number;
  fileData: File = null;
  profilePicture: string;
  userDisplayName: any;
  userData: any;
  showDefaultImage: boolean;
  email: any;
  phone: any;
  info: any;
  website: any;
  uname: any;
  name: any;
  iname: string;
  _steps = [];
  images: any = [];
  allfiles: any = [];
  allfile: any = [];
  videos: any = [];
  flows: any;
  information: string;
  description: string;
  stepToEdit: any;
  showImageorVideo: boolean;
  Url: string;
  posterUrl: string;
  Description: string;
  showVideo: boolean;
  showMedia: string;
  showImage: boolean;
  stepIndex: number;
  isStepCoverPageURISet: boolean;
  fileName: string;
  noResultReturned: boolean;
  isLoading: boolean;
  progress: number;
  videoUrl: string;
  videoPosterUrl: string;
  title: string;
  currenttitlelenght = 0;
  maxtitlelenght = 80;
  @Input() embedded: boolean = false;
  @Output() closeEmbedded = new EventEmitter<void>();

  constructor(
    private userserviceService: UserserviceService,
    private flowServiceService: FlowServiceService,
    private dataService: DataService,
    private router: Router,
    private dialog:MatDialog,
    private toastManager: ToastrService, 
    private http: HttpClient,
    private _activatedRoute: ActivatedRoute,
    private getContentService:GetContentService,
    private mediaUploadService: MediaUploadService,
    @Optional() public dialogRef?: MatDialogRef<StepsComponent>

  ) {
    this._steps = [];
    this.stepIndex = -1;
    this.stepToEdit = JSON.parse(localStorage.getItem("stepToEdit"));
    if (this.stepToEdit != null) {
      this.Url = this.stepToEdit.stepToEdit.Url;
      this.posterUrl = this.stepToEdit.stepToEdit.posterUrl;
      this.Description = this.stepToEdit.stepToEdit.Description;
      this.title = this.stepToEdit.stepToEdit.title;
      this.showImage = this.stepToEdit.stepToEdit.showImage;
      this.showVideo = this.stepToEdit.stepToEdit.showVideo;
      this.stepIndex = this.stepToEdit.index;
      this.fileName = this.stepToEdit.stepToEdit.stepFileName;
    } else {
      this.Url = "";
      this.Description = "";
      this.title = "";
      this.stepIndex = -1;
      this.posterUrl = "";
    }

    if (this.Url != "") {
      this.isStepCoverPageURISet = true;
    } else {
      this.isStepCoverPageURISet = false;
    }
  }

  ngOnInit(): void {
    this.flowServiceService.setScrollTop();
    this.information = JSON.parse(localStorage.getItem("information"));
    this.noResultReturned = true;
    // 
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.showNotificationCount = false;
    this.notificationCount = 4;
    //
    this.noResultReturned = false;
    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
    }
    this.dataService.setFlowByCategorieschangeMessage.subscribe((flowData) => {
      this.flows = flowData;
      this.flows = JSON.parse(localStorage.getItem("flowByCategory"));
    });


    this._steps = JSON.parse(localStorage.getItem("stepsCoverPageDetails"));
  }
  originalContentTitleText!: string;
  repharaseButtonText: string = "Rephrase text with AI";
  isRephrased: boolean = false;
  isRephraseInProgress: boolean = false;
 
  GoToOriginalText() {
    this.Description = this.originalContentTitleText;
  }

  rephraseDescriptionText() {
    const dialogRef = this.dialog.open(SelectionRephraseAIComponent, {
      width: '400px',
      data: { textToRephrase: this.Description }  // Pass the text to the dialog
    });
    if (!this.isRephrased) {
      this.originalContentTitleText = this.Description;
      console.log(this.Description);
    }
    this.isRephraseInProgress = true;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Update the title with the rephrased text and show the selected style  
        this.Description = result.rephrasedText;
        console.log('Selected style:', result.selectedStyle);
        this.isRephrased = true;
        this.isRephraseInProgress = false;
      }
    });
  }

  titleChanged() {
    this.title = this.title.trim();

    if (this.title.length == this.maxtitlelenght) {
      this.title = this.title.substring(0, this.title.length);
    }

    if (this.currenttitlelenght <= this.maxtitlelenght)
      this.currenttitlelenght = this.title.length;
 
  }

  done() {
    var stepsCoverPage = {
      url: this.Url,
      posterUrl: this.posterUrl,
      description: this.Description,
      stepFileName: this.fileName,
      title : this.title
    };


    if (this._steps == null) {
      this._steps = [];
      this._steps.push(stepsCoverPage);
    } else if (this.stepIndex >= 0) {
      var stepValue = this._steps[this.stepIndex];


      if (stepValue != undefined) {
        stepValue.description = this.Description;
        stepValue.url = this.Url;
        stepValue.title = this.title;
        this._steps.splice(this.stepIndex, 1, stepValue);
      } else {
        this._steps.push(stepsCoverPage);
      }
    } else {
      this._steps.push(stepsCoverPage);
    }

    localStorage.setItem("stepsCoverPageDetails", JSON.stringify(this._steps));
    if (this.dialogRef) {
      this.dialogRef.close(true);
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  createFlow() {
    if (this.dialogRef) {
      this.dialogRef.close(true);
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  SignOut() {
    localStorage.setItem("LoggedInUser", null);
    this.userDisplayName = null;
    this.router.navigate(["/"]);
  }
  checkLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: this.router.url }
      }); 
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: this.router.url }
      }); 
    }
  }

  close() {
    localStorage.setItem("stepsCoverPageDetails", JSON.stringify(this._steps));
    if (this.dialogRef) {
      this.dialogRef.close(true);
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  removePicture() {
    this.profilePicture = null;
  }

  getFileName(fileName) {
    return fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2);
  }

  async selectFiles(event: any) {
    if (event.target.files) {
      this.noResultReturned = true;
      this.fileData = <File>event.target.files[0];
      this.fileName = this.fileData.name;
      this.isStepCoverPageURISet = true;
      this.isLoading = true;
   
      // File type detection
      const imageExtensions = ["jpeg", "jpg", "png", "gif", "jfif", "tiff", "tif", "pdf", // From your list, normalized
        "bmp", "webp", "svg", "heic", "heif", "raw", "arw", "cr2",
        "nef", "orf", "rw2", "dng", "psd", "ico", "exif", "pjpeg",
        "ppm", "pgm", "pbm", "pnm", "xpm", "tga", "pcx", "jp2",
        "jpx", "eps", "ai"];
      const videoExtensions = ["mp4", "mov", "wmv", "flv", "avchd", "webm", "mkv", "vob", // From your list
        "ogv", "gifv", "m4p", "m4v", "3gp", "3g2", "amv", "nsv",
        "ogg", "f4v", "f4p", "f4a", "f4b", // From your list
        "avi", "mts", "m2ts", "ts", "mpg", "mpeg", "rm", "rmvb",
        "divx", "xvid", "asf", "mxf", "dv", "h264", "h265", "vp8",
        "vp9", "prores", "swf", "dat", "bik", "av1", "vro", "svi"];
  
      const isImage = imageExtensions.some(ext => this.fileData.name.includes(ext));
      const isVideo = videoExtensions.some(ext => this.fileData.name.includes(ext));

      let fileToUpload = this.fileData;
      if (isVideo) {
        try {
          fileToUpload = await this.mediaUploadService.prepareFileForUpload(this.fileData);
          this.fileData = fileToUpload;
        } catch (error: any) {
          this.isLoading = false;
          this.noResultReturned = false;
          this.fileName = '';
          this.toastManager.warning(error?.message || this.mediaUploadService.uploadTooLargeMessage());
          return;
        }
      }

      const formData = new FormData();
      formData.append("fileData", fileToUpload);
      
      const uploadUrl = isImage 
        ? environment.apiBaseUrl + environment.uploadImageUrl 
        : environment.apiBaseUrl + environment.uploadVideoUrl;
  
      this.http
        .post(uploadUrl, formData, {
          reportProgress: true,
          observe: 'events'
        })
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                break;
              case HttpEventType.ResponseHeader:
                break;
              case HttpEventType.UploadProgress: {
                if (event.total !== undefined) {
                  const progress = (event.loaded / event.total) * 100;
                  if (progress !== 100) {
                    this.progress = progress;
                  }
                }
                break;
              }
              case HttpEventType.Response:
                this.handleFileUpload(event, isImage);
                break;
            }
          },
          (error) => {
            this.isLoading = false;
            this.noResultReturned = false;
            this.fileName = '';
            this.toastManager.warning(this.mediaUploadService.uploadTooLargeMessage());
            console.error('An error occurred:', error);
          }
        );
      }
  }
  
  handleFileUpload(res: HttpResponse<any>, isImage: boolean) {
    this.isLoading = false;
    this.noResultReturned = false;
    const mediaUploadStatus = res.body as any;
    
    if (mediaUploadStatus != null) {
      if (isImage) {
        this.showImage = true;
        this.showVideo = false;
        this.Url = environment.imageStorageBaseUrl + mediaUploadStatus.fileName;
      } else {
        this.showVideo = true;
        this.showImage = false;
        this.Url = environment.videoStorageBaseUrl + mediaUploadStatus.fileName;
        this.posterUrl = environment.imageStorageBaseUrl + mediaUploadStatus.posterImageName;
      }
      this.toastManager.success("File has been uploaded successfully.");
      this.progress = 100;
    } else {
      // Handle null response
      alert(mediaUploadStatus?.message || "Upload failed");
    }
  }
}
